import { Icon, IconProps } from "semantic-ui-react";

type BPIconProps = IconProps & {}
export function BPIcon(props: BPIconProps) {
    return <Icon {...props}>{props.children}</Icon>;
} 